export default __webpack_public_path__ + "static/media/javascript.8923d575.jpg";